/**
 * @generated SignedSource<<6287682bf3386be3999d61df1da2fd2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceEditQuery$variables = {
  id: string;
};
export type OrgSpaceEditQuery$data = {
  readonly storecastSpace: {
    readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceEdit_space">;
  };
};
export type OrgSpaceEditQuery = {
  response: OrgSpaceEditQuery$data;
  variables: OrgSpaceEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgSpaceEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastSpace",
        "kind": "LinkedField",
        "name": "storecastSpace",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrgSpaceEdit_space"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgSpaceEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastSpace",
        "kind": "LinkedField",
        "name": "storecastSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4df37a6be3f8f0e96fce8256ba03444c",
    "id": null,
    "metadata": {},
    "name": "OrgSpaceEditQuery",
    "operationKind": "query",
    "text": "query OrgSpaceEditQuery(\n  $id: ID!\n) {\n  storecastSpace(id: $id) {\n    ...OrgSpaceEdit_space\n    id\n  }\n}\n\nfragment OrgSpaceEdit_space on StorecastSpace {\n  id\n  name\n}\n"
  }
};
})();

(node as any).hash = "dffe96b8fe4729c074c76b57e2dd5e42";

export default node;
